import { t } from '@lingui/macro';
import { matchPath } from 'react-router';
import { useHistory } from 'react-router-dom';

import { ROUTES } from '../../../../routes';
import {
    LeftNavButtonProps, OpenModuleOptions
} from '../components/left-nav-button';
import { LeftButtons } from '../left-nav';
import { ModuleTypes } from '@api';

export const useLeftNavButton = () => {
    const history = useHistory();
    const handleOpenModule = ({
        moduleId,
        groupId,
        moduleType
    }: OpenModuleOptions) => {
        if (moduleType === ModuleTypes.content) {
            history.push(`${ROUTES.content}/${moduleId}`);
        } else if (moduleType === ModuleTypes.landing) {
            history.push(`${ROUTES.landing}/${groupId}`);
        } else if (moduleType === ModuleTypes.welcome) {
            history.push(ROUTES.welcome);
        }
    };
    const getIsActive = ({
        groupId,
        moduleType,
        moduleIds
    }: OpenModuleOptions) => {
        const matchWelcome = matchPath(history.location.pathname, { path: ROUTES.welcome });
        const isWelcomeModuleActive = matchWelcome?.isExact && moduleType === ModuleTypes.welcome;

        if (isWelcomeModuleActive) {
            return true;
        }

        const matchContentModule = matchPath<{ moduleId: string }>(
            history.location.pathname, { path: ROUTES.contentByModuleId }
        );
        const contentModuleId = matchContentModule && parseInt(matchContentModule?.params.moduleId);
        const isContentModuleActive = contentModuleId && moduleIds?.includes(contentModuleId);

        if (isContentModuleActive) {
            return true;
        }

        const matchLandingModule = matchPath<{ groupId: string }>(
            history.location.pathname,
            { path: ROUTES.landingByGroupId }
        );

        return matchLandingModule?.isExact &&
        matchLandingModule.params.groupId === groupId;
    };
    const getLeftNavButtonProps = (buttonProps: LeftButtons) => {
        return {
            ...buttonProps,
            onOpenModule: handleOpenModule,
            isActive: getIsActive({
                moduleType: buttonProps.moduleType,
                moduleId: buttonProps.moduleId,
                groupId: buttonProps.groupId,
                moduleIds: buttonProps.moduleIds
            })
        };
    };
    const getHomeNavButtonProps = (): LeftNavButtonProps => {
        const homeModuleType = ModuleTypes.welcome;

        return {
            onOpenModule: () => handleOpenModule({ moduleType: homeModuleType }),
            isActive: getIsActive({ moduleType: homeModuleType }),
            icon: 'home',
            text: t`menu.home`,
            tooltip: t`menu.home.tooltip`,
            moduleType: homeModuleType,
            moduleId: 0,
            groupId: '',
            moduleIds: [],
            moduleLink: '',
            isAvailableForOneRosterSchoolOnly: true,
            isHiddenForOneRosterSchool: false
        };
    };

    return {
        getLeftNavButtonProps,
        getHomeNavButtonProps
    };
};
